define((require) => {
    "use strict";

    const {Model}            = require("backbone");
    const LoggedInUserState  = require("shared/ui/user/LoggedInUserState");
    const CompanyState       = require("shared/data/CompanyState");
    const RestApi            = require("shared/services/RestApi");

    /**
     * Company model.
     *
     * @class CompanyModel
     * @constructor
     */
    const CompanyModel = Model.extend({ // TODO: why is the state not mapped?

        defaults: {
            name: null
        },

        url() {
            const id = this.get("id") || LoggedInUserState.get("principal").get("companyId");
            return RestApi.pathToSpecificResource(RestApi.Collections.COMPANIES, id);
        },

        toString() {
            return `Company[id: ${this.get("id")}; name: ${this.get("name")}]`;
        }

    }, {
        State: CompanyState
    });

    return CompanyModel;
});



// WEBPACK FOOTER //
// ./src/editor/data/CompanyModel.js